import { Helmet } from "react-helmet-async"
import { useEffect } from "react"
import { useLocale } from "../contexts/LocaleContext"

function SEO({
  title,
  description,
  canonical,
  image = "https://www.gymjourney.fit/assets/og-gym-journey.png",
  type = "website",
  noIndex = false,
  datePublished,
  dateModified,
  alternates,
}) {
  const { t, locale } = useLocale()

  const robots = noIndex ? "noindex, follow" : "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1";
  const ogLocale = locale === "fr" ? "fr_FR" : "en_US";
  const keywords = t.seo.home?.keywords || "";
  const enHref = alternates?.en || canonical
  const frHref = alternates?.fr || canonical
  const xDefault = alternates?.xDefault || enHref

  useEffect(() => {
    document.querySelectorAll([
      'link[rel="canonical"]:not([data-rh])',
      'link[rel="alternate"][hreflang]:not([data-rh])',
      'meta[name="description"]:not([data-rh])',
      'meta[name="robots"]:not([data-rh])',
      'meta[name="keywords"]:not([data-rh])',
      'meta[property^="og:"]:not([data-rh])',
      'meta[name^="twitter:"]:not([data-rh])',
    ].join(",")).forEach((node) => node.remove())
  }, [canonical, robots, title, description])

  return (
    <Helmet>
      <html lang={locale} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <meta name="keywords" content={keywords} />

      {/* Canonical */}
      <link rel="canonical" href={canonical} />

      <link rel="alternate" hrefLang="en" href={enHref} />
      <link rel="alternate" hrefLang="fr" href={frHref} />
      <link rel="alternate" hrefLang="x-default" href={xDefault} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Article Metadata */}
      {type === "article" && (
        <>
          {datePublished && <meta property="article:published_time" content={datePublished} />}
          {dateModified && <meta property="article:modified_time" content={dateModified} />}
        </>
      )}
    </Helmet>
  )
}

export default SEO